import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'myDate',
})
export class DatePipe implements PipeTransform {
  /**
   * Takes a string and returns a moment date value
   * @param value: string
   * @param format: string
   */
  transform(value: string, format: string) {
    return moment(value).format(format);
  }
}
